module.exports = __webpack_public_path__ + "img/notebook-icon.36f6b902.png";